export const ConsumerPostSubmissionApprovedReferenceCodeUat = {
  referenceCode: 'workflow.postSubmissionApproved.referenceCode.code',
  description: 'workflow.postSubmissionApproved.referenceCode.description',
}
